const USER_NOT_FOUND_MESSAGES = new Set([
  'User not found',
  'User does not exist by the provided email',
]);

export function isUserNotFoundError(error: string): boolean {
  return USER_NOT_FOUND_MESSAGES.has(error);
}
